import { createSelector } from 'reselect';

import { StoreState } from '../../../reducers';
import { ImportFileState } from '../../ImportManager/reducer';

export const getFilesToDisplay = createSelector(
	(state: StoreState): { [key: string]: ImportFileState } => state.importManager.byId,
	(byId: { [key: string]: ImportFileState }): ImportFileState[] => (
		Object.values(byId).filter(({ shouldDisplayInToast }) => shouldDisplayInToast)
	)
);

export const getFilesToDisplayIds = createSelector(
	getFilesToDisplay,
	(filesToDisplay: ImportFileState[]): string[] => filesToDisplay.map(({ id }) => id as string)
);

export const getImportedFilesNumber = createSelector(
	getFilesToDisplay,
	(filesToDisplay: ImportFileState[]): number => filesToDisplay.filter(({ isImportFinished }) => isImportFinished).length
);

export const getFilesWithErrorNumber = createSelector(
	getFilesToDisplay,
	(filesToDisplay: ImportFileState[]): number => filesToDisplay.filter(({ error }) => !!error).length
);

export const getCanceledFilesNumber = createSelector(
	getFilesToDisplay,
	(filesToDisplay: ImportFileState[]): number => filesToDisplay.filter(({ isImportCanceled }) => isImportCanceled).length
);

const getUploadingFiles = createSelector(
	getFilesToDisplay,
	(filesToDisplay: ImportFileState[]): ImportFileState[] => filesToDisplay.filter(({ isImportFinished, isImportCanceled, error }) => (
		!isImportFinished && !isImportCanceled && !error
	))
);

export const getUploadingFilesSize = createSelector(
	getUploadingFiles,
	(uploadingFiles: ImportFileState[]): number => uploadingFiles.reduce((acc, current) => {
		acc += current.file!.size;
		return acc;
	}, 0)
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ImportDesktopFile/Toast/selectors.tsx